export default "__VITE_ASSET__62bb2474__"